import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import VisibilitySensor from "react-visibility-sensor";

import img1 from "../../../assets/img/warehouseStructure/warehouseEight/img1.webp";

function WarehouseEight(){

    const { t } = useTranslation();
    const [isVisible, setIsVisible] = useState(false);

    const onChange = (visibility) => {
      if (visibility) {
        setIsVisible(true);
      }
    };

    return(
        <VisibilitySensor onChange={onChange} partialVisibility minTopValue={100}>
            <div className="warehouseEight">
              <img className={`${isVisible ? 'visible' : ''}`} src={img1} alt="" width={'250px'} />
              <h1 className={`${isVisible ? 'visible' : ''}`}>{t("warehouse_eight_title")}</h1>
              <p className={`${isVisible ? 'visible' : ''}`}>
                {t("warehouse_eight_text")}
              </p>
            </div>
        </VisibilitySensor>
    )
}
export default WarehouseEight;
